




















































import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
import SearchStore from '@/store/SearchStore.brain';
import DetailStore from '@/store/DetailStore';

@Component({
    components: {}
})
export default class Graph2dContentApp extends Vue {
    isHide = window['_screenType'] === '2160';
    searchData = SearchStore.state;
    detailData = DetailStore.state;

    get historyList() {return this.searchData.historyList}

    zoomIn () {
        this.$bus.$emit('force-zoom-in');
    }

    zoomOut () {
        this.$bus.$emit('force-zoom-out');
    }

    fullScreen () {
        DetailStore.changeLoading({type: 'leftRight', flag: !this.detailData.loading.leftRight})
    }

    resetForceGraph () {
        this.$bus.$emit('force-graph-reset');
    }

    clickHandler (item) {
        SearchStore.setSearchItem(item);
        // TODO 复用
        let {subjectId, entityType} = this.searchData.searchItem;
        if (entityType === 'user') {
            DetailStore.getUserDataBySubjectId(subjectId);
            DetailStore.getUserGraph({subjectId});
        } else if (entityType === 'poi') {
            DetailStore.getPoiDataBySubjectId(subjectId);
            DetailStore.getPoiGraph({subjectId});
        }
    }
}
